import React from 'react';
import { Check, Clock, Package } from 'lucide-react';
import { plans } from '../mock';
import { Button } from './ui/button';

const iconMap = {
  1: Clock,
  2: Package,
  3: Check
};

const Plans = ({ onOpenOrder }) => {
  return (
    <section id="planos" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Planos de Entrega
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Escolha a frequência que melhor se encaixa na sua rotina
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan) => {
            const Icon = iconMap[plan.id];
            return (
              <div key={plan.id} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border-2 border-orange-100 hover:border-orange-300">
                <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-xl flex items-center justify-center mb-6">
                  <Icon className="h-7 w-7 text-white" />
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {plan.name}
                </h3>
                <p className="text-gray-600 mb-4">{plan.description}</p>
                
                <div className="space-y-3 mb-6">
                  <div className="flex items-center text-gray-700">
                    <Check className="h-5 w-5 text-green-600 mr-2" />
                    <span>{plan.meals}</span>
                  </div>
                  <div className="flex items-center text-gray-700">
                    <Check className="h-5 w-5 text-green-600 mr-2" />
                    <span>{plan.flexibility}</span>
                  </div>
                </div>
                
                <Button onClick={onOpenOrder} className="w-full bg-orange-600 hover:bg-orange-700">
                  Escolher Plano
                </Button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Plans;